<template>
    <footer>
        <div class="section-divider"></div>
        <div class="footer-main-block pt-3 pb-4">
            <div class="container mw-80">
                <div class="row gy-4 d-flex align-items-center mt-3 mb-5">
                    <div class="col-12 col-md-12 col-lg-3 f-logo text-center text-lg-left">
                        <a class="navbar-brand" href="#">
                            <img src="@/assets/img/logo-mobile.png" alt="Exiles Logo" lazy>
                        </a>
                    </div>
                    <div class="col-12 col-md-12 col-lg-5 text-center text-lg-left">
                        <p class="mb-2">Trademarks and brands are the property of their respective owners.</p>
                        <p class="mb-2">Exiles is not affiliated with Jagex or RuneScape. To play RuneScape, visit <a href="https://runescape.com">runescape.com</a></p>
                        <p class="mb-2">Use of this website is subject to our <router-link to="/terms">Terms of Service</router-link> & <router-link to="/privacy">Privacy Policy</router-link>.</p>
                        <p class="mb-2">Copyright © 2025-2026 Exiles | All rights reserved.</p>
                    </div>
                    <div class="col-12 col-md-12 col-lg-4 text-center text-lg-right">
                        <div class="footer-grid mt-5 mb-4">
                            <div id="links-b" class="col footer-links text-center">
                                <ul>
                                    <li><h5>Community</h5></li>
                                    <li><router-link to="/login">Login</router-link></li>
                                    <li><router-link to="/register">Register</router-link></li>
                                    <li><router-link to="/account">Account</router-link></li>
                                    <li><a href="https://discord.com/invite/3yt9kXRdax" target="_blank">Discord</a></li>
                                </ul>
                            </div>
                            <div id="links-c" class="col footer-links text-center">
                                <ul>
                                    <li><h5>Support</h5></li>
                                    <li><router-link to="/terms">Terms</router-link></li>
                                    <li><router-link to="/privacy">Privacy Policy</router-link></li>
                                    <li><router-link to="/rules">Rules</router-link></li>
                                    <li><router-link to="/faq">FAQ</router-link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                
            </div>
        </div>
    </footer>
</template>

<script setup>
const getCurrentYear = () => {
    return new Date().getFullYear()
}
</script>
